import React from 'react';
import { motion } from 'framer-motion';
import { SiblingFigure } from '../characters/SiblingFigure';
import { siblings } from '../../data/siblings';
interface CharacterGalleryProps {
  compact?: boolean;
}

/** Solventum on the outside, personality on the inside. */
export function CharacterGallery({
  compact = false
}: CharacterGalleryProps) {
  return <figure className={['rounded-[24px] border border-[rgba(1,51,43,0.1)] bg-white', compact ? 'mt-6 p-4' : 'mt-9 p-6'].join(' ')} data-id="element-116" data-mp="koq0qp2ehdhk">
      <div className={['grid', compact ? 'grid-cols-2 gap-4' : 'grid-cols-2 gap-5 sm:grid-cols-3 lg:grid-cols-5'].join(' ')} data-id="element-117" data-mp="arv6iid5tz93">
        {siblings.map((sibling, i) => <motion.div key={sibling.id} initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.4
      }} transition={{
        delay: i * 0.08,
        duration: 0.5,
        ease: [0.22, 1, 0.36, 1]
      }} className="flex flex-col items-center text-center" data-id="element-118" data-mp="1tswxefd1ya7" data-mpi={i}>
            <SiblingFigure role={sibling.id} className={compact ? 'h-[68px] w-[68px]' : 'h-[92px] w-[92px]'} data-id="element-119" data-mp="3gsjeljymuff9" />
            <span className={['mt-3 font-heading leading-tight text-background', compact ? 'text-[13px]' : 'text-[15px]'].join(' ')} data-id="element-120" data-mp="32u39tykbyyzr">
              {sibling.label}
            </span>
            <span className="mt-1 font-body text-[10.5px] leading-snug" style={{
          color: sibling.accent
        }} data-id="element-121" data-mp="3ddcsot2w4xq">
              {sibling.trait}
            </span>
          </motion.div>)}
      </div>
      <figcaption className={['border-t border-[rgba(1,51,43,0.1)] font-body leading-relaxed text-[rgba(1,51,43,0.55)]', compact ? 'mt-4 pt-3 text-[11px]' : 'mt-6 pt-4 text-[12px]'].join(' ')} data-id="element-122" data-mp="3qocv1efh2t2b">
        The cast. Corporate design system on the outside, illustrated personalities on
        the inside — the contrast is what makes it noticeable.
      </figcaption>
    </figure>;
}